import React from "react";
import { Link } from "react-router-dom";
import Theme from "./theme";

const RelatedJobs = (props) => {
  const { jobs } = props;

  return (
    <Theme>
      <h4 className="title is-4">Related Job Ads</h4>
      <div className="columns">
        {jobs.slice(0, 2).map((job) => (
          <div className="column is-half-desktop">
            <Link to={`/job/${job._id}`}>
              <div onClick={() => window.scrollTo(0, 0)} className="box">
                <p className="jobTitle">{job.title}</p>
                <p>{job.company.name}</p>
                <p className="compensation">{job.compensation}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
      <div className="columns">
        {jobs.slice(2, 4).map((job) => (
          <div className="column is-half-desktop">
            <Link to={`/job/${job._id}`}>
              <div onClick={() => window.scrollTo(0, 0)} className="box">
                <p className="jobTitle">{job.title}</p>
                <p>{job.company.name}</p>
                <p className="compensation">{job.compensation}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </Theme>
  );
};

export default RelatedJobs;
